import React from 'react'
import { Flex } from 'reflexbox'
import { Link } from 'react-router-dom'

import Button from 'components/Button'
import { Title } from 'components/Typography'

import BeneficiaryGroupsDataListing from 'containers/BeneficiaryGroupsDataListing'

const GroupsIndex = () => {
  return (
    <Flex flexDirection='column' width={1}>
      <Flex justifyContent='space-between' alignItems='center' mb={40}>
        <Title as='h3'>Grupos de Beneficiários</Title>
        <Button size='big' as={Link} to='/prepaid-purchase/groups/new'>
          Adicionar grupo
        </Button>
      </Flex>
      <BeneficiaryGroupsDataListing />
    </Flex>
  )
}

export default GroupsIndex
